import { groupDataByKeys } from './groupDataByKeys';
export const buildGroupedData = (dataToGroup, depth, dateGroupingFunctions, rowDateKeyExtractor) => {
    const grouped = groupDataByKeys(dataToGroup, depth, dateGroupingFunctions, rowDateKeyExtractor);
    const isGroupArray = Array.isArray(grouped);
    const isMaxDepth = depth >= dateGroupingFunctions.length - 1;
    const shouldReturnGroupedAsIs = isGroupArray || isMaxDepth;
    if (shouldReturnGroupedAsIs) {
        return grouped;
    }
    const nextDepth = depth + 1;
    const groupedEntries = Object.entries(grouped);
    const result = groupedEntries.reduce((accumulator, [key, group]) => {
        const isNestedArray = Array.isArray(group);
        const nestedGroup = isNestedArray
            ? buildGroupedData(group, nextDepth, dateGroupingFunctions, rowDateKeyExtractor)
            : group;
        accumulator[key] = nestedGroup;
        return accumulator;
    }, {});
    return result;
};
